import { AbstractControl, ValidatorFn } from '@angular/forms';

export function validOperationModesSelection(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const selectedValues = control.value;
    if (!selectedValues) {
      return;
    }
    const selectedCodes = control.value.map(({ code }) => code);
    const validCombinations = [
      [],
      ['ATT'],
      ['SS'],
      ['SS', 'CCR'],
    ];

    const isValid = validCombinations.some(combination => 
      combination.length === selectedCodes.length && 
      combination.every(value => selectedCodes.includes(value))
    );

    return isValid ? null : { invalidOperationModesSelection: { value: control.value } };
  };
}